import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../lib/angular/injection-tokens';
import { IAppConfig } from '../lib/config/app-config';

@Injectable({
  providedIn: 'root',
})
export class PublicContentObjectService {
  private baseUrl: string = this.config.publicBaseUrl;
  private static readonly path: string = 'PublicContentObject/';

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) {}

  public getPathByObjectId$(objectId: string): Observable<string> {
    return this.http.get(this.baseUrl + PublicContentObjectService.path + 'path/' + objectId , {responseType: 'text'});
  }
}
